import Clipboard from 'clipboard';
import { elMessage } from './index';

const clipboardSuccess = () => {
    // console.log("复制成功")
    // 你可以在这里设置你的提示
    elMessage('success', '复制成功')
}
const clipboardError = () => {
    // console.log("复制失败")
    elMessage('error', '复制失败')
}

export const handleCopy = (text, event, onSuccess?, onError?) => {
    event = event || {};
    const clipboard: any = new Clipboard(event.target, {
        text: () => text,
    });
    clipboard.on('success', () => {
        onSuccess ? onSuccess() : clipboardSuccess();
        clipboard.off('error');
        clipboard.off('success');
        clipboard.destroy();
    });
    clipboard.on('error', () => {
        onError ? onError() : clipboardError();
        clipboard.off('error');
        clipboard.off('success');
        clipboard.destroy();
    });
    clipboard.onClick(event);
}